import { render, staticRenderFns } from "./ProductLicencePeriodList.vue?vue&type=template&id=5a1f57ee&scoped=true&"
import script from "./ProductLicencePeriodList.vue?vue&type=script&lang=js&"
export * from "./ProductLicencePeriodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1f57ee",
  null
  
)

export default component.exports